import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Breadcrumbs as BreadcrumbsBase, Typography } from "@mui/material";
import { StyledLink } from "./index.style";
import breadcrumbList from "./config.json";
import Watermark from "./Watermark";

interface BreadcrumbList {
  [key: string]: { [key: string]: string };
}

export const Breadcrumbs = () => {
  const [breadcrumbs, setBreadcrumbs] = useState<{
    [key: string]: string;
  }>({});

  const location = useLocation();

  useEffect(() => {
    const bcs = breadcrumbList as BreadcrumbList;
    let path = location.pathname;

    if (!bcs[path]) {
      const pieces = path.split("/");

      if (parseInt(pieces[pieces.length - 1]) >= 0) {
        pieces[pieces.length - 1] = ":id";
        path = pieces.join("/");
      }
    }

    if (!bcs[path]) {
      return;
    }

    setBreadcrumbs(bcs[path]);
  }, [location]);

  const renderBreadcrumbs = () => {
    const result = [];

    for (const key of Object.keys(breadcrumbs)) {
      const breadcrumb = breadcrumbs[key];

      if (key === "") {
        result.push(
          <Typography color="text.primary" key={"breadcrumb-#" + key}>
            {breadcrumb}
          </Typography>
        );
        continue;
      }

      result.push(
        <StyledLink color="primary" key={"breadcrumb-#" + key} to={key}>
          {breadcrumb}
        </StyledLink>
      );
    }

    return result;
  };

  if (breadcrumbs === undefined || breadcrumbs === null) {
    return <></>;
  }

  return (
    <>
      <BreadcrumbsBase
        aria-label="breadcrumb"
        separator={">"}
        style={{ marginBottom: "10px" }}
      >
        {renderBreadcrumbs()}
      </BreadcrumbsBase>
      <Watermark />
    </>
  );
};
